import React from "react";

export function ContentItem(props) {
    return (
        <div
            className={`flex flex-col items-center justify-center w-full min-w-xs overflow-hidden mb-20 text-base font-bold md:text-sm lg:text-base md:mb-0 ${
                props.className ? props.className : ""
            }`}
        >
            <a
                href={props.href}
                className="relative"
                draggable={false}
            >
                <div className="absolute bottom-6 w-full text-center text-white">
                    {props.label}
                </div>
                <img
                    className="max-w-xl w-full rounded-3xl select-none object-fill"
                    src={props.img}
                    draggable={false}
                />
            </a>
        </div>
    );
}
